<template>
    <div>
        <div class="text-16 font-regular text-a-blue-2140a6 pb-1.5">
            {{inputLbl.name}}
        </div>
        <div class="relative" :class="[isError ? 'pb-12' : 'pb-5']">
            <input type="tel"
                class="w-full bg-a-blue-f2f5ff rounded-sm h-12 px-3 py-1 placeholder-a-gray-a4a4a4 text-a-blue-001b73"
                :class="[isError ? '' : '']"
                v-model="content"
                :placeholder="inputLbl.placeholder"
                :maxlength="inputMaxLength"
                :data-cy="$attrs['data-cy']"
                @input="onChange()"
                @click="onClick()">
            <div class="text-a-red-ff4d4d text-16 font-regular absolute bottom-5 left-0 w-full" v-if="isError">
                {{getErrorMsg}}
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputNumber",
    props: {
        // v-model
        inputValue:     { type: [String, Number] },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    data: function() {
        return {
            content: this.inputValue,
            inputMaxLength: null,
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        }
    },
    created: function() {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
        },
        onChange: function() {
            let result = this.content;
            result = RegxHelper.removeNotNumber(result);

            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
        onClick: function(){
            this.$emit('onClick');
        }
    },
}
</script>
<style lang="scss" scoped>

</style>
